import useSWR from 'swr'
import React, { Suspense } from 'react'
import { getPhenomenaTypes } from '@futures-platform/connectors/drupal-api'
// import { ContentCardType } from '../components/ContentCardType'
import { ContentCardType } from '@futures-platform/ui'
import { getPhenomenaStatistic } from '../helpers/phenomenonFetcher'
import { isEmpty } from '../helpers/utils'
import { translatePhenomenonAlias } from '../helpers/utils'
import styles from './CardHeader.module.css'

const CardHeaderOnMainContent = ({
  phenomenonType: phenomenonTypeProp,
  gid,
  rid,
  pid,
  phenomenon: phenProps,
  lang,
}) => {
  let phenomenonType = phenomenonTypeProp
  const { data: phenomenonTypeDataRes } = useSWR(
    phenomenonType ? 'getPhenomenaData' + gid : null,
    async () => {
      return await getPhenomenaTypes(gid || 0)
    },
  )
  if (!phenomenonType) {
    phenomenonType = phenomenonTypeDataRes
  }
  const phenomenonTypeData = React.useMemo(() => {
    return !!phenomenonType?.length && !!phenProps?.content?.type
      ? phenomenonType?.filter((type) => type?.id === phenProps?.content?.type)
      : []
  }, [phenProps?.content?.type, phenomenonType])
  const phenomenon = React.useMemo(() => {
    let phenTemp = { ...phenProps?.content } ?? {}
    phenTemp['color'] =
      !!phenProps &&
      !!phenomenonTypeData &&
      !!phenomenonTypeData?.length &&
      !!phenomenonTypeData[0]?.style?.color &&
      phenProps?.content?.type?.includes('fp:doc-types')
        ? phenomenonTypeData[0]?.style?.color || 'none'
        : 'none'
    if (
      phenTemp['color'] === 'none' &&
      !phenomenonTypeData?.length &&
      !!phenProps?.content?.type?.includes('fp:doc-types')
    ) {
      phenTemp['content-type-alias'] = 'undefined'
      phenTemp['content-type-title'] = '(no type)'
    } else {
      phenTemp['content-type-alias'] =
        phenomenonTypeData &&
        !!phenomenonTypeData?.length &&
        phenomenonTypeData[0]?.alias
      phenTemp['content-type-title'] =
        phenomenonTypeData &&
        !!phenomenonTypeData?.length &&
        phenomenonTypeData[0]?.title
    }
    phenTemp['phen-data'] = { ...phenProps }
    phenTemp['phenomenonType'] = !!phenomenonType && [...phenomenonType]

    return phenTemp
  }, [phenomenonType, phenomenonTypeData, phenProps])
  // const {iconClassName, backgroundColor} = phenomenonColor(phenomenon);
  const { translationTitle } = translatePhenomenonAlias(phenomenon, lang)
  const { data: crowdsourcedData } = useSWR(
    `statistic/${gid}/${rid}/${pid}`,
    async () => {
      return await getPhenomenaStatistic(pid)
    },
  )

  const filteredByValue = React.useMemo(() => {
    return (
      !!crowdsourcedData &&
      Object.fromEntries(
        Object.entries(crowdsourcedData?.data).filter(
          ([key, value]) => key?.toString() === pid?.toString(),
        ),
      )
    )
  }, [crowdsourcedData, pid])

  const statictis = React.useMemo(() => {
    return filteredByValue[pid]
  }, [filteredByValue, pid])

  const crowdsourced = !!statictis
    ? String(statictis?.['year_median'])?.split('.')[0]
    : null

  const isFpGroup =
    Number(phenomenon?.['phen-data']?.group) === 0 ||
    (!!phenomenon?.['phen-data']?.groups?.length &&
      Number(phenomenon?.['phen-data']?.groups[0]) === 0)

  return phenomenon && !isEmpty(phenomenon) ? (
    <>
      <div className={styles.cardHeaderWrapper}>
        <div className={styles.headerWrapper}>
          {/* {
             phenomenon?.['color'] === 'none' && <div className={`icon-issue ${iconClassName}`} style={{marginTop: '2.5px'}}></div>
          }
          {
            phenomenon?.['color'] !== 'none' && <div className=' w_h_16' style={{backgroundColor: `${backgroundColor}`, marginTop: '6px', borderRadius: '9999px'}}></div>
          } */}
          {phenomenon?.['content-type-alias'] !== null && (
            <div className={styles.contentCardWrapper}>
              <ContentCardType
                customTypeStyleColor={phenomenon?.color}
                contentType={phenomenon?.['content-type-alias']}
                isFpGroup={isFpGroup}
                fontSizePhen={'16'}
                // phenomenon={completedPhenomenon}
                // isFpGroup={isFpGroup}
              />
            </div>
          )}
          <p className={styles.phenTitle}>
            {phenomenon?.['color'] === 'none'
              ? translationTitle
              : phenomenon?.['content-type-title']}
          </p>
          {((!!phenomenon?.time_range && !!phenomenon?.time_range?.min) ||
            crowdsourced) && <span className={styles.verticalLine}></span>}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
            }}>
            {!!phenomenon?.time_range &&
              !!phenomenon?.time_range?.min &&
              !!phenomenon?.time_range?.max && (
                <p className={styles.timeRange}>{`${
                  !!phenomenon?.time_range?.min
                    ? phenomenon?.time_range?.min
                    : ''
                } - ${
                  !!phenomenon?.time_range?.max
                    ? phenomenon?.time_range?.max
                    : ''
                }`}</p>
              )}
            <Suspense fallback={''}>
              {!!crowdsourced && (
                <p className={styles.crowdsourced}>
                  {'Crowdsourced: '}
                  {crowdsourced ?? ''}
                </p>
              )}
            </Suspense>
          </div>
        </div>
      </div>
    </>
  ) : null
}

export default CardHeaderOnMainContent
